export class ChangeInThemeForceStatusNotification
{
    public Expiration: Date;
    public IsForceAllThemes: boolean;
    public IsOn: boolean;
    public IsOnWithDuration: boolean;
    public LocationId: number;
    public ThemeId: number;
    public ThemeNumber: number;
    public TypeCode: number;

    constructor(json: object = null)
    {
        if (json)
        {
            Object.assign(this, json);

            this.Expiration = new Date(json['Expiration']);
        }
    }
}
